module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/functional-categories/functional-categories.component.css
// module id = ./src/app/functional-categories/functional-categories.component.css
// module chunks = main